<div class="action-panel composer-panel">
  <div class="action-panel-header">
    <i class="fa fa-pencil-square-o" style="margin-right:6px;"></i>
    {{ title }}
  </div>

  <div class="action-panel-body">
    <form-error-summary [errors]="fieldErrors" (jumpTo)="jumpToField($event)"></form-error-summary>

    <div class="composer-questions">
      <ng-container *ngFor="let question of questions">
        <open-question *ngIf="isOpenQuestion(question)"
                       [type]="'composer'"
                       [question]="getQuestionKey(question)"
                       [editor]="getQuestion(question)"
                       [submitted]="submitted">
        </open-question>
        <tick-box *ngIf="!isOpenQuestion(question)"
                  [fields]="question"
                  [type]="'composer'"
                  [submitted]="submitted">
        </tick-box>
      </ng-container>
    </div>

    <div class="composer-actions">
      <button (click)="confirm()" class="btn btn-primary action-btn">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
